// import Script from 'next/script';
import React from 'react';

interface MonitorScriptProps {
  id: number; //  MonitorID 查询 https://c1ey4wdv9g.larksuite.com/wiki/wikusHNfCpneVfvUeADG4LWkbUb?table=tblPuHWU4mSe6xen&view=vewRDwPkml
}

export const MonitorScript: React.FC<MonitorScriptProps> = (props) => {
  if (process.env.NODE_ENV !== 'production') {
    return null;
  }

  const url = `/common-static/infra-static/monitor/monitor.latest.js?id=${props.id}`;
  return (
    <script data-index="0" crossOrigin="anonymous" src={url} />
  );
  // return <script crossOrigin="anonymous"  src={url} />;
};
